/* @flow */

import type { RootState, Action } from "../types";
import { combineReducers } from "redux";
import sandboxSignupReducer from "./sandboxSignup";

const combinedReducer = (
  countryCode: string,
  countries: Array<string>
): ((RootState | void, Action) => RootState) =>
  combineReducers({
    formState: sandboxSignupReducer(countryCode, countries),
    countryCode: (state = countryCode) => state || "",
    countries: (state = countries) => state || []
  });

const reducer = (countryCode: string, countries: Array<string>) => (
  state: RootState | void,
  action: Action
) => {
  const nextState = state;

  const newState = combinedReducer(countryCode, countries)(nextState, action);

  return {
    ...newState
  };
};

export default reducer;
